import { FC } from 'react';
import { useDispatch } from 'react-redux';
import {
  setPortfolioShouldRefresh,
  setPortfolioUpdatedNotesCount,
} from '../../../store/portfolio/PortfolioActions';
import { DealType } from '../../../types/DealType';
import { NotesCountMap } from '../../../types/Note';
import { IPitchStatusState } from '../../../types/PitchStatus';
import DealPitchStatus from '../../shared/deal-pitch-status/DealPitchStatus';
import NotesModal from '../../shared/react-table-wrapper/notes-modal/NotesModal';

type PortfolioNotesModalProps = {
  dealType: DealType;
  dealerId: string;
  leadId: string;
  fullName: string;
  vin: string;
  status: string;
  subStatus: string;
  notesCountMap: NotesCountMap[];
  isNotesModalOpen: boolean;
  openNotesModal: (value: boolean) => void;
  onPitchStatusChange?: (value: IPitchStatusState) => void;
};

const PortfolioNotesModal: FC<PortfolioNotesModalProps> = (props) => {
  const dispatch = useDispatch();
  const refreshPortfolio = () => {
    dispatch(setPortfolioShouldRefresh(true, props.dealType));
  };
  const updateNotesCount = (value: NotesCountMap) => {
    dispatch(setPortfolioUpdatedNotesCount(value, props.dealType));
  };

  const titleComponent: JSX.Element = (
    <DealPitchStatus
      dealerId={props.dealerId}
      leadId={props.leadId}
      vin={props.vin}
      status={props.status}
      subStatus={props.subStatus}
      onPitchStatusChange={props.onPitchStatusChange}
      refreshPortfolio={refreshPortfolio}
      isNotesModalOpen={props.isNotesModalOpen}
    ></DealPitchStatus>
  );

  return (
    <>
      <NotesModal
        dealerId={props.dealerId}
        leadId={props.leadId}
        fullName={props.fullName}
        vin={props.vin}
        notesCountMap={props.notesCountMap}
        isNotesModalOpen={props.isNotesModalOpen}
        openNotesModal={props.openNotesModal}
        updateNotesCount={updateNotesCount}
        titleComponent={titleComponent}
      />
    </>
  );
};

export default PortfolioNotesModal;
